module.exports = __webpack_public_path__ + "img/app-slug.7fc53cc7.svg";